/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Effacer la sélection',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Impossible de récupérer les données',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Cliquez pour réessayer',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Chargement en cours…',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Afficher plus',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} sur {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Résultats introuvables',
  'paginated-picker.async-select.select.option.error-message': 'Impossible de récupérer les données',
  'paginated-picker.async-select.select.option.retry-message': 'Cliquez pour réessayer',
  'paginated-picker.async-select.select.search-placeholder': 'Rechercher',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Afficher toute la liste',
};
